import FetchAthleteGamelog from "../../FetchGamelog";
import { useState, useEffect, useRef } from "react";
import Chart from 'chart.js/auto';

export default function LastFiveStatsModal({ termId, athlete, closeModal }) {
  const [gamelog, setGamelog] = useState([]);
  const [loading, setLoading] = useState(true);
  const statKey = athlete.stat_key.replace('projected_', '');
  const statID = athlete.stat_id;
  const chartRef = useRef(null);

  const data = {
    labels: gamelog.map(event => `${event.date} vs ${event.opponent}`),
    datasets: [
      {
        label: `${athlete.stat_display} vs Opponents`,
        data: gamelog.map(event => event.stats[statKey]),
        backgroundColor: 'rgba(206, 36, 36, 0.2)', // #ce2424 with 20% opacity
        borderColor: '#ce2424',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      new Chart(chartRef.current, {
        type: 'bar',
        data: data,
        options: options,
      });
    }
  }, [gamelog, statID]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await FetchAthleteGamelog(termId, statKey, statID);
      setGamelog(result || []);
      setLoading(false);
    };
    fetchData();
  }, [termId, statKey, statID]);

  return (
    <div
      className="modal fade mt-5 show"
      id="last-five-stats-modal"
      style={{ display: 'block' }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="last five stats"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <div className="stat-title">
              {athlete.stat_display} History
            </div>
            <button
              type="button"
              className="close"
              onClick={() => closeModal()}
              aria-label="Close"
              data-dismiss="modal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pt-1">

            <img
              height="120"
              alt={athlete.name}
              src={athlete.image}
            />
            <div className="stat-title">{athlete.name}</div>
            <p className="mb-0">
              vs. {athlete.opponent_short}
            </p>
            <p className="avg mb-1">
              {athlete.stat} {athlete.stat_display}{" "}
              Average
            </p>
            {loading ? (
              <div className="mt-4">
                <div className="spinner-border" role="status" />
                <p>Loading...</p>
              </div>
            ) : !gamelog?.length ? (
              <div className="mt-4">
                <p>No stats available</p>
              </div>
            ) : (
              <div>
                <canvas ref={chartRef} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}